import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const RegistrationCompleteIcon: React.FC<IconProps> = (props) => (
  <>
    
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-6 w-6 text-green-600"
      {...props}
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  </>
);

export default RegistrationCompleteIcon;
